module.exports = __webpack_public_path__ + "media/images/home-lulu-b197ba55d934b19b8417e93f3aa3b1df.jpg";